/* eslint-disable eqeqeq */
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
// common_groupstructure_GETROW
import Grid from "@mui/material/Grid";
import WmsHead from "./processComponent/WmsHead";
import "./DcRebateDetailReport.css";
import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import { ReportRemoveSequenceChar, ReportUrl } from "../../Utility/Utilitys";

import {
  HeadObjectInit,
  sWebStockReportData,
  sWebStockReportArr,
  GetLocation,
  fValidationHead_Client,
  sWebBetweenReportArr,
  GetWmsStockRepotMainSupplier,
} from "./DcRebateDetailReportAction";
import WmsContent from "./processComponent/WmsContent";

// import { set } from 'date-fns/esm';

export default function DcRebateDetailReport() {
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const [sMainSupplierData, setMainSupplierData] = useState([]);

  //Head
  const [HeadObject, setHeadObject] = useState(HeadObjectInit);

  const [sLocationData, setLocationData] = useState([
    // { Uid: "Distribution", Value: "Distribution" },
  ]);
  const [sDCLocationData, setDCLocationData] = useState([
    // { Uid: "Distribution", Value: "Distribution" },
  ]);

  //Head

  const fLocation = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sLocation: e.target.value,
      sLocationArr: [],
      sLocationPrnt: "",
      sLocationName: "",
    }));
  };
  const fDCLocation = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDCLocation: e.target.value,
      sDCLocationArr: [],
      sDCLocationPrnt: "",
      sDCLocationName: "",
    }));
  };

  // const fLocation_MultiSelect = async (value) => {
  //   console.log(value);

  //   let currentPrnt = value.map((option) => option.Cd).join(",");
  //   let currentName = value.map((option) => option.Name1).join(",");

  //   setHeadObject((obj) => ({
  //     ...obj,
  //     sLocationArr: value,
  //     sLocationPrnt: value?.length <= 0 ? "" : currentPrnt,
  //     sLocationName: value?.length <= 0 ? "" : currentName,
  //   }));
  // };

  const checkBoxFunction = async (e, option, selected) => {
    // console.log(e.target.checked  ,option,selected);
    // if(option.Cd == 'All'){
    //   if (e.target.checked) {
    //     // setSelectedItems([]); // Unselect all if "All" is already selected'
    //     let currentPrnt = sLocationData.map((option) => option.Cd).join(",");
    //     let currentName = sLocationData.map((option) => option.Name1).join(",");
    //     setHeadObject((obj) => ({
    //       ...obj,
    //       sLocationArr: sLocationData,
    //       sLocationPrnt: sLocationData?.length <= 0 ? "" : currentPrnt,
    //       sLocationName: sLocationData?.length <= 0 ? "" : currentName,
    //     }));
    //   } else {
    //     setHeadObject((obj) => ({
    //       ...obj,
    //       sLocationArr: [],
    //       sLocationPrnt: "",
    //       sLocationName: "",
    //     }));
    //     // setSelectedItems(options); // Select all options
    //   }
    // }else{
    //    let previousData = HeadObject.sLocationArr;
    //    let updatedData = [];
    //    if(e.target.checked){
    //     previousData.push(option);
    //     updatedData = previousData;
    //     }else{
    //     updatedData = previousData.filter(obj => obj.Cd !== option.Cd);
    //    }
    //  let currentPrnt = updatedData.map((option) => option.Cd).join(",");
    // let currentName = updatedData.map((option) => option.Name1).join(",");
    // setHeadObject((obj) => ({
    //   ...obj,
    //   sLocationArr: updatedData,
    //   sLocationPrnt: updatedData?.length <= 0 ? "" : currentPrnt,
    //   sLocationName: updatedData?.length <= 0 ? "" : currentName,
    // }));
    // }
  };

  const fLocation_MultiSelect = async (value) => {
    console.log(value);

    let oldValue = HeadObject.sLocationArr;
    let newValue = value;
    let lengthOfOldValue = HeadObject.sLocationArr.length;
    let lengthOfNewValue = value.length;
    let originalData = sLocationData;
    let lengthOfOriginalData = sLocationData.length;

    let updatedValue = [];

    // Find newly added items (items present in newValue but not in oldValue)
    let addedItems = newValue.filter(
      (newItem) =>
        !oldValue.some(
          (oldItem) =>
            oldItem.Cd === newItem.Cd &&
            oldItem.Name1 === newItem.Name1 &&
            oldItem.BranchCode === newItem.BranchCode &&
            oldItem.BranchName === newItem.BranchName
        )
    );

    // Find removed items (items present in oldValue but not in newValue)
    let removedItems = oldValue.filter(
      (oldItem) =>
        !newValue.some(
          (newItem) =>
            newItem.Cd === oldItem.Cd &&
            newItem.Name1 === oldItem.Name1 &&
            newItem.BranchCode === oldItem.BranchCode &&
            newItem.BranchName === oldItem.BranchName
        )
    );
    let hasAllCd = newValue.some((item) => item.Cd === "All");

    if (addedItems.length == 1) {
      if (addedItems[0].Cd == "All") {
        updatedValue = originalData;
      } else {
        // Remove the object with Cd: 'all' from newValue
        if (newValue.length == lengthOfOriginalData - 1) {
          updatedValue = originalData;
        } else {
          // Remove the object with Cd: 'all' from newValue
          updatedValue = newValue.filter((item) => item.Cd !== "All");
        }
      }
    }

    if (removedItems.length == 1) {
      if (removedItems[0].Cd == "All") {
        updatedValue = [];
      } else {
        if (hasAllCd) {
          // Remove the object with Cd: 'all' from newValue
          updatedValue = newValue.filter((item) => item.Cd !== "All");
        } else {
          // Remove the object with Cd: 'all' from newValue
          updatedValue = newValue.filter((item) => item.Cd !== "All");
        }
      }
    }
    // if(lengthOfOriginalData == lengthOfNewValue){

    // }

    //     const isAllkey= value.some((option) => option.Cd === 'All');
    //     const isSelectedValue = value.filter((option) => option.Cd !== 'All');
    //     const isoriginalValue = sLocationData.filter((option) => option.Cd !== 'All');

    //     let finalArray=value
    //     if(isSelectedValue.length == isoriginalValue.length && !isAllkey ){
    //       finalArray=    [{ "Cd": "All", "Name1": "All", "BranchCode": "", "BranchName": "" }, ...finalArray]
    //     }else if(isSelectedValue.length != isoriginalValue.length  && isAllkey){
    // finalArray=isSelectedValue
    //     }
    if (value.length == 0) {
      updatedValue = [];
    }
    let repValue = updatedValue.filter((item) => item.Cd !== "All");
    let currentPrnt = repValue.map((option) => option.Cd).join(",");
    let currentName = repValue.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sLocationArr: updatedValue,
      sLocationPrnt: repValue?.length <= 0 ? "" : currentPrnt,
      sLocationName: repValue?.length <= 0 ? "" : currentName,
    }));
  };
  const fDCLocation_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");

    setHeadObject((obj) => ({
      ...obj,
      sDCLocationArr: value,
      sDCLocationPrnt: value?.length <= 0 ? "" : currentPrnt,
      sDCLocationName: value?.length <= 0 ? "" : currentName,
    }));
  };

  //common_VendorListReport_GETROW
  const fMainSupplier = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sMainSupplierArr: [],
      sMainSupplierPrnt: "",
      sMainSupplierName: "",
    }));
    if (e.target.value.toUpperCase() == "ALL") {
      setMainSupplierData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotMainSupplier(setMainSupplierData);
    }
  };
  const fMainSupplier_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sMainSupplierArr: value,
      sMainSupplierPrnt: value?.length <= 0 ? "" : currentPrnt,
      sMainSupplierName: value?.length <= 0 ? "" : currentName,
    }));
  };
  const fDate = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDate: e.target.value,
      sFromDate: new Date(),
      sToDate: new Date(),
    }));
  };
  const fFromDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: e?.$d,
      }));
    }
  };
  const fToDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: e?.$d,
      }));
    }
  };

  const fCancel = (e) => {
    setHeadObject(HeadObjectInit);
  };

  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const GetReportsView = async () => {
    let urlPrint = vRdxDBKernObj?.WEB_REPORT_BASE_URL?.Val;
    let sCurrentReport = "";
    const suplGrpData = HeadObject?.sMainSupplierArr
      .map((x) => x.AcCd)
      .join(",");

    let ReportUrlObj = {
      // UserCd: vRdxuserInfo.UserID,
      Trntyp:
        selectedOption === "SUPPLIERWISE"
          ? sBufferObj.sDetailSuppierWise === "Y"
            ? "SUPPLIERWISEPIVOT"
            : "SUPPLIERWISE"
          : selectedOption === "BRANCHWISE"
          ? "BRANCHWISE"
          : selectedOption === "BRANDWISE"
          ? sBufferObj.sDetailBrandWise === "Y"
            ? "BRANDWISEPIVOT"
            : "BRANDWISE"
          : selectedOption === "ITEMWISE"
          ? sBufferObj.sDetailItemWise === "Y"
            ? "ITEMWISEPIVOT"
            : "ITEMWISE"
          : sBufferObj.sDetailReportRadioBtnName,
      Date1: moment(HeadObject.sFromDate).format("MM-DD-YYYY"),
      Date2: moment(HeadObject.sToDate).format("MM-DD-YYYY"),
      LocCSV: HeadObject.sLocationPrnt,
      LocDCCSV: HeadObject.sDCLocationPrnt,
      Supplier: suplGrpData == "" ? "All" : suplGrpData,
    };
    console.log(ReportUrlObj);
    sCurrentReport = ReportUrl(ReportUrlObj);

    sCurrentReport = ReportRemoveSequenceChar(sCurrentReport);

    console.log("sCurrentReport", urlPrint + "WMS/DCRebate?" + sCurrentReport);
    setWebReportUrlModal(urlPrint + "WMS/DCRebate?" + sCurrentReport);
    console.log(urlPrint + "WMS/DCRebate?" + sCurrentReport);

    fWebReport();
  };

  const fPreview = async (e) => {
    let iValidationHead_Client = fValidationHead_Client(HeadObject, sBufferObj);
    if (!iValidationHead_Client) return;

    await GetReportsView();
  };

  //Modal fWebReportModal
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const fLoad = async () => {
    await GetLocation(setLocationData, setDCLocationData);
  };

  const sBufferObjInit = {
    sDetailReportRadioBtnName: "DETAIL",
    sDetailSuppierWise: "N",
    sDetailBrandWise: "N",
    sDetailItemWise: "N",
  };

  const [sBufferObj, setBufferObj] = useState(sBufferObjInit);
  const [selectedOption, setSelectedOption] = useState("");

  console.log("sDetailReportRadioBtnName", sBufferObj);
  const fSuppierWise = (e) => {
    if (selectedOption !== "SUPPLIERWISE") return;

    setBufferObj((obj) => ({
      ...obj,
      sDetailSuppierWise: e.target.checked ? "Y" : "N",
    }));
  };

  const fBrandWise = (e) => {
    if (selectedOption !== "BRANDWISE") return;

    setBufferObj((obj) => ({
      ...obj,
      sDetailBrandWise: e.target.checked ? "Y" : "N",
    }));
  };

  const fItemWise = (e) => {
    if (selectedOption !== "ITEMWISE") return;

    setBufferObj((obj) => ({
      ...obj,
      sDetailItemWise: e.target.checked ? "Y" : "N",
    }));
  };

  useEffect(() => {
    fLoad();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div></div>
        <div className="col-12">
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 3 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={vMediaQuery ? "py-4" : "py-4"}
          >
            <Grid item xs={12} sm={12} md={8}>
              <WmsHead
                checkBoxFunction={checkBoxFunction}
                fLocation_MultiSelect={fLocation_MultiSelect}
                fDCLocation_MultiSelect={fDCLocation_MultiSelect}
                sLocationData={sLocationData}
                sDCLocationData={sDCLocationData}
                sWebStockReportData={sWebStockReportData}
                sWebStockReportArr={sWebStockReportArr}
                HeadObject={HeadObject}
                setHeadObject={setHeadObject}
                fLocation={fLocation}
                fDCLocation={fDCLocation}
                fFromDate={fFromDate}
                fToDate={fToDate}
                fDate={fDate}
                sWebBetweenReportArr={sWebBetweenReportArr}
                fMainSupplier={fMainSupplier}
                fMainSupplier_MultiSelect={fMainSupplier_MultiSelect}
                sMainSupplierData={sMainSupplierData}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <WmsContent
                DetailReportRadioBtn={(e) => {
                  const value = e.target.value;

                  setSelectedOption(value);
                  setBufferObj((prev) => ({
                    ...prev,
                    sDetailReportRadioBtnName: value, // optional if you use this elsewhere
                    sDetailSuppierWise:
                      value === "SUPPLIERWISE" ? prev.sDetailSuppierWise : "N",
                    sDetailBrandWise:
                      value === "BRANDWISE" ? prev.sDetailBrandWise : "N",
                    sDetailItemWise:
                      value === "ITEMWISE" ? prev.sDetailItemWise : "N",
                  }));
                }}
                selectedOption={sBufferObj.sDetailReportRadioBtnName}
                fSuppierWise={fSuppierWise}
                fBrandWise={fBrandWise}
                fItemWise={fItemWise}
                sBufferObj={sBufferObj}
              />
            </Grid>
          </Grid>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 0, md: 0 }}
            columnSpacing={{ xs: 1, sm: 0, md: 3 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              vMediaQuery
                ? " justify-content-center text-center"
                : "py-2 justify-content-center text-center"
            }
          >
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Preview"
                xOnClick={fPreview}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Cancel"
                xOnClick={fCancel}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
          </Grid>
        </div>
      </div>

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
